import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { RecurrenceModel } from 'src/models/recurrence.models'
import { convertUTCRecurringLabel, extendWeekdays } from 'src/utils/date.utils'

interface RecurrenceFrequencyLabelProps {
  className?: string
  recurrence: RecurrenceModel
  timezone: string
}

const RecurrenceFrequencyLabel: React.FC<RecurrenceFrequencyLabelProps> = (
  props,
): React.ReactNode => {
  const translate = useTranslate()

  if (props.recurrence.byWeekDay !== undefined) {
    return props.recurrence.interval === 1
      ? translate('Every Week, on ${byWeekDay}', {
          byWeekDay: extendWeekdays(props.recurrence.byWeekDay),
        })
      : translate('Every ${interval} Weeks, on ${byWeekDay}', {
          interval: `${props.recurrence.interval}`,
          byWeekDay: extendWeekdays(props.recurrence.byWeekDay),
        })
  } else if (props.recurrence.byMonthDay !== undefined) {
    return props.recurrence.interval === 1
      ? translate('Every Month, on the ${byMonthDay}', {
          byMonthDay: convertUTCRecurringLabel(
            `${props.recurrence.byMonthDay}-01-3000`,
            'DD-MM-YYYY',
            props.timezone,
          ).format('Do'),
        })
      : translate('Every ${interval} Months, on the ${byMonthDay}', {
          interval: `${props.recurrence.interval}`,
          byMonthDay: convertUTCRecurringLabel(
            `${props.recurrence.byMonthDay}-01-3000`,
            'DD-MM-YYYY',
            props.timezone,
          ).format('Do'),
        })
  } else if (props.recurrence.byYearDay !== undefined) {
    return translate('Every Year, on ${byYearDay}', {
      byYearDay: convertUTCRecurringLabel(
        `${props.recurrence.byYearDay} 3000`,
        'DDD YYYY',
        props.timezone,
      ).format('MMMM D'),
    })
  } else {
    return props.recurrence.interval === 1
      ? translate('Every Day')
      : translate('Every ${interval} Days', {
          interval: `${props.recurrence.interval}`,
        })
  }
}

export default RecurrenceFrequencyLabel
